import { createTheme } from '@mui/material';
import { colors, getTheme } from '@truvhq/ui';

import { MOBILE_BREAKPOINT } from 'shared/lib/screen/useScreenSize';

const MOBILE = `@media (max-width: ${MOBILE_BREAKPOINT - 1}px)`;

// Mobile fields are taller, rounder and set a step up from their desktop counterpart, and
// carry a visible ring at rest. The ring is an `outline` rather than a border because the base
// theme paints focus and error on the notched border — an outline layers over that and can be
// dropped in those states without touching either rule.
export const theme = createTheme(getTheme(), {
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          [MOBILE]: {
            'minHeight': 48,
            'borderRadius': 15,
            'fontSize': 15,
            'outline': `1px solid ${colors.grey40}`,
            'outlineOffset': -1,

            '&.Mui-focused, &.Mui-error': {
              outlineColor: 'transparent',
            },
          },
        },
        input: {
          [MOBILE]: {
            height: 25,
            lineHeight: '25px',
          },
        },
      },
    },
  },
});
